import { AlertModel } from "../models/alertModel";
import { AlertActionTypes, EDIT_ALERT, SET_ALERT } from "../types/actions";

const alertReducerDefaultState: AlertModel = {
    id: '', name: '', show: false, properties: {
        message: '',
        displayTime: 0,
        notificationType: '',
        position: 'top-right',
        alertTransition:'Bounce',
    }
};

const alertReducer = (state: AlertModel = alertReducerDefaultState, action: AlertActionTypes): AlertModel => {
    switch (action.type) {
        case SET_ALERT:
            return action.alert;
        case EDIT_ALERT:
            return { ...state, ...action.alert }
        default:
            return state;
    }
}

export default alertReducer
